









































import Vue, { PropType } from "vue";
import Locale from "@/lib/locale";

export interface PaypalIframeProps {
  customParameters: String;
  merchantId: String;
  planCurrency: String;
  subtotal: String;
  redirectUrl: String;
  paypalIframeUrl: String;
}

export interface PaypalIframeData {
  locale: string;
}

export default Vue.extend({
  name: "vc-paypal-iframe",
  props: {
    customParameters: {
      type: String as PropType<PaypalIframeProps["customParameters"]>,
      default: "plan=1&user=10497"
    },
    merchantId: {
      type: String as PropType<PaypalIframeProps["merchantId"]>,
      default: ""
    },
    planCurrency: {
      type: String as PropType<PaypalIframeProps["planCurrency"]>,
      default: "JPY"
    },
    subtotal: {
      type: String as PropType<PaypalIframeProps["subtotal"]>,
      default: "1"
    },
    redirectUrl: {
      type: String as PropType<PaypalIframeProps["redirectUrl"]>,
      default: ""
    },
    paypalIframeUrl: {
      type: String as PropType<PaypalIframeProps["paypalIframeUrl"]>,
      default: ""
    }
  },
  data(): PaypalIframeData {
    return {
      locale: Locale.getPaypalLocale(Locale.getLocale())
    };
  },
  mounted() {
    this.sendFormToPaypalIframe();
  },
  methods: {
    sendFormToPaypalIframe() {
      const formElement = this.$refs.formIframe as HTMLFormElement;
      formElement.submit();
    }
  },
  watch: {
    customParameters() {
      this.sendFormToPaypalIframe();
    },
    plan() {
      this.sendFormToPaypalIframe();
    }
  }
});
